import { useState } from "react";
import { useTranslation } from "react-i18next";

const loadedLanguages = ["en"]; // our default language that is preloaded

export const usei18n = () => {
  const {
    i18n: { changeLanguage, language }
  } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(language);

  const setI18nLanguage = (langStr: string) => {
    setCurrentLanguage(langStr);
    document.querySelector("html")?.setAttribute("lang", langStr);
    changeLanguage(langStr);
    return langStr;
  };

  const getLanguage = () => {
    let navigatorLang = navigator.language.slice(0, 2)?.toLocaleLowerCase();
    if (!["en", "fr"].includes(navigatorLang)) navigatorLang = "en";
    const localStorageLang = localStorage.getItem("i18n");
    const languageQuery = new URLSearchParams(document.location.search).get("language");

    const currentLanguage =
      languageQuery || (localStorageLang !== "" && localStorageLang) || navigatorLang || "en";
    return ["en", "fr"].includes(currentLanguage) ? currentLanguage : "en";
  };

  const setLanguage = async (lang?: string | string[]) => {
    let navigatorLang = navigator.language.slice(0, 2)?.toLocaleLowerCase();
    if (!["en", "fr"].includes(navigatorLang)) navigatorLang = "en";
    const langStr = (typeof lang === "string" ? lang : lang?.[0]) || getLanguage();
    if (langStr !== navigatorLang && langStr !== "") {
      localStorage.setItem("i18n", langStr);
      localStorage.setItem("language", langStr);
    } else {
      localStorage.removeItem("i18n");
      localStorage.removeItem("language");
    }

    // If the same language
    if (currentLanguage === langStr) {
      return Promise.resolve(setI18nLanguage(langStr));
    }

    // If the language was already loaded
    if (loadedLanguages.includes(langStr)) {
      return Promise.resolve(setI18nLanguage(langStr));
    }

    // If the language hasn't been loaded yet
    try {
      changeLanguage(langStr);
      loadedLanguages.push(langStr);
      return setI18nLanguage(langStr);
    } catch (err) {
      console.error(err);
      return Promise.resolve(setI18nLanguage("en"));
    }
  };
  return { setLanguage, getLanguage };
};
